import React, { FC, Fragment } from "react";
import { Collapse, List, ListItem } from "@mui/material";

import SidebarSectionItem from "./components/SidebarSectionItem";

import { useSidebarStateStore } from "@store/sidebar";
import { Box } from "@components/base";

interface SidebarSection {
  currentPath: string;
  items: SidebarSectionItem[];
}

const SidebarSection: FC<SidebarSection> = ({ items, currentPath }) => {
  const { sidebarCollapsed } = useSidebarStateStore();

  return (
    <List>
      {items.map((item) => (
        <Fragment key={item.path}>
          {item.isVisible && (
            <ListItem
              disableGutters
              disablePadding
              sx={{
                transition: "padding 0.5s",
                display: "block",
                mb: 0.5,
                py: 0,
                px: sidebarCollapsed ? 1 : 2,
              }}
              key={item.path}
            >
              <SidebarSectionItem
                title={item.title}
                path={item.path}
                icon={item.icon}
                hasChip={item.hasChip}
                active={
                  item.path === currentPath ||
                  (item.path !== "/" &&
                    currentPath.slice(1).startsWith(item.path.slice(1)) &&
                    !item.children?.map((ch) => ch.path).includes(currentPath))
                }
              />
              {item.children && (
                <Collapse
                  in={
                    (item.path === currentPath ||
                      item.children.findIndex(
                        (child) => child.path === currentPath,
                      ) > -1 ||
                      (item.path !== "/" &&
                        currentPath.slice(1).startsWith(item.path.slice(1)))) &&
                    !sidebarCollapsed
                  }
                >
                  <Box mx={1}>
                    {item.children?.filter(child => child.isVisible).map((child, index) => (
                      <SidebarSectionItem
                        key={`sidebar-section-${item.path}-${index}`}
                        title={child.title}
                        path={child.path}
                        icon={child.icon}
                        active={child.path === currentPath}
                      />
                    ))}
                  </Box>
                </Collapse>
              )}
            </ListItem>
          )}
        </Fragment>
      ))}
    </List>
  );
};

export default SidebarSection;
